export default __webpack_public_path__ + "static/media/Firebase.b1c2c3da.png";